import { tv } from 'tailwind-variants';

import { fontStyles } from './typography';

export const linkStyles = tv({
  base: 'bg-transparent border-0 cursor-pointer p-0 disabled:cursor-default disabled:opacity-50 disabled:pointer-events-none text-decoration-none',
  variants: {
    underline: {
      true: 'hover:underline active:underline',
      false: '',
    },
    font: fontStyles.variants.variant,
    color: {
      default: 'text-token-gray-1600',
      purple: 'text-token-purple-900',
    },
  },
  defaultVariants: {
    color: 'default',
  },
});
